import { render, staticRenderFns } from "./MainLedgerAutoKnjizenje.vue?vue&type=template&id=60cc31a8&scoped=true"
import script from "./MainLedgerAutoKnjizenje.vue?vue&type=script&lang=js"
export * from "./MainLedgerAutoKnjizenje.vue?vue&type=script&lang=js"
import style0 from "./otvoreneStavke.css?vue&type=style&index=0&id=60cc31a8&prod&scoped=true&lang=css&external"
import style1 from "./MainLedgerAutoKnjizenje.vue?vue&type=style&index=1&id=60cc31a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc31a8",
  null
  
)

export default component.exports